<router-outlet></router-outlet>

@if(pageLoaderDetails.show) {
<kzn-loader [message]="pageLoaderDetails.message" [isOverlay]="true"></kzn-loader>
}